// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-4c57fea3],a[data-v-4c57fea3]:link{color:#0062bd!important}.v-breadcrumbs[data-v-4c57fea3]{padding:3px 20px;background:#f6f6f6}.ba-logo[data-v-4c57fea3]{height:40px;position:relative;width:auto;left:120px;left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
